import React from 'react';
import { Site } from '../../lib/Site';
import SiteFooterNavigation from './SiteFooterNavigation';
import SiteFooterNavigationReduced from './SiteFooterNavigationReduced';
import SiteFooterSub from './SiteFooterSub';

interface Props {
    site: Site;
    isFocused?: boolean;
    isReduced?: boolean;
}

interface FooterWrapperProps {
    site: Site;
    children?: React.ReactNode;
}

function FooterWrapper({ site, children = null }: FooterWrapperProps) {
    return (
        <footer role="contentinfo">
            <div className="site-footer">
                {children}
                <SiteFooterSub site={site} />
            </div>
        </footer>
    );
}

export default function SiteFooter({ site, isFocused = false, isReduced = false }: Props) {
    if (isReduced) {
        return (
            <FooterWrapper site={site}>
                <SiteFooterNavigationReduced site={site} />
            </FooterWrapper>
        );
    } else if (isFocused) {
        return <FooterWrapper site={site} />;
    }
    return (
        <FooterWrapper site={site}>
            <SiteFooterNavigation site={site} />
        </FooterWrapper>
    );
}
